(function ($) {
  'use strict';


  $('#sa-search-main, #headerSearchForm').autocomplete({
    minLength : 3,
    source : getAutocompleteSource('/vyhledavani.html'),
    select : handleSelection
  }).data('ui-autocomplete')._renderItem = renderAutocompleteItem;

  function handleSelection (event, ui) {
    window.location.href = ui.item.link;
    return false;
  }

  function getAutocompleteSource (url) {

    return getData;

    function getData (req, res) {

      $.ajax({
        type: 'GET',
        dataType: 'xml',
        minLength: 3,
        url: url,
        data: {
          query: req.term,
          ajax: 1
        },
        success: handleSuccessfulResponse(res),
        error: handleError
      });
    }

    function handleSuccessfulResponse (res) {

      return function (data) {

        var results = [];
        var items = $('item', data);

        items.forEach((item) =>
          results.push({
            link : [ $('link', item).text() ],
            title : [ $('title', item).text() ],
            perex : [ $('perex', item).text() ],
            icon : [$('icon', item).text()]
          })
        );

        res(results);
      };
    }

    function handleError (response) {
      console.log(response);
    }
  }

  function renderAutocompleteItem (ul, item) {

    var text = '';
    if (item.img.type === 'next') {
      text += `<a href="${item.link}" class="search-link-next">${item.title}</a>`;
    } else {
      text += `<a href="${item.link}">`;
      if (item.img !== null) {
        text += `<img src="${item.img}" />`;
      }
      text += '<strong>' + item.title + '</strong>';
      if (item.desc !== null) {
        text += `<br /><span>${item.desc}</span>`;
      }
      text += '</a>';
    }
    return $('<li></li>').data('item.autocomplete', item).append(text).appendTo(ul);
  }
})(jQuery);

/*
  $('#sa-search-main, #headerSearchForm').autocomplete({
    minLength : 3,
    source : function(request, response) {
      var term = request.term;
      $.ajax({
        type : 'GET',
        async : false,
        dataType : 'xml',
        minLength: 3,
        url : '/vyhladavanie.html',
        data : {
          query : term,
          locale : 'cs',
          ajax : '1'
        },
        success : function(xml) {
          var res = [];
          var items = $('item', xml);
          for ( var i = 0; i < items.length; i++) {
            var item = items[i];
            var r = {
              type : [ $('type', item).text() ],
              img : [ $('img', item).text() ],
              link : [ $('link', item).text() ],
              title : [ $('title', item).text() ],
              desc : [ $('desc', item).text() ]
            }
            res.push(r);
          }
          response(res);
        }
      })
    },

    search : function(event, ui) {
    },

    focus : function(event, ui) {
      return false;
    },

    select : function(event, ui) {
      window.location = ui.item.link;
      return false;
    }
  })

  .data('ui-autocomplete')._renderItem = function(ul, item) {

    var text = '';
    if (item.img.type == 'next') {
      text += `<a href="${item.link}" class="search-link-next">${item.title}</a>`;
    } else {
      text += `<a href="${item.link}">`;
      if (item.img != null) {
        text += `<img src="${item.img}" />`;
      }
      text += '<strong>' + item.title + '</strong>';
      if (item.desc != null) {
        text += `<br /><span style="color:#EA4C89'">${item.desc}</span>`;
      }
      text += '</a>';
    }
    return $('<li></li>').data('item.autocomplete', item).append(text).appendTo(ul);
  };
*/
